export default __webpack_public_path__ + "static/media/1.3fd0f346.jpg";